<template lang="pug">

  .pie-view-wrapper

    .graph-total
      div(style="display: flex; align-items: center; justify-content: center;")
        span.fs-19 {{ displayInfo.title }}
        span.fs-13 ({{ displayInfo.period }})

      .line
        .change-chart-type
          span.icon-ptt-icons-grafico.to-click(style="padding: 2px;" @click="$emit('changeChartType', {id: 'bars'})")
          span.icon-ptt-icons-pizza.background-primary(style="padding: 2px")

        .full-screen
          span.icon-ptt-icons-expandir.to-click.fs-21.full-screen-togler(
            @click="$emit('toggleFullScreen')"
          )

      BarsChart(
        v-if="totalFormated && !totalGraph.loading",
        :data="totalFormated",
        :scrollable="false",
        :barsWidth="20",
        ref="total",
        :options="barsChartConfig",
        key="barsChart",
        @click="loadCompaniesGraph"
      )

      BarsChart(
        v-if="totalGraph.loading",
        :data="loadingData.bars",
        :barsWidth="20",
        key="barsChartLoading",
        :options="{animation: {duration: 7000, easing: 'easeInOutBounce'}}"
      )

    .companies-title
      template(v-if="companiesGraph.data || companiesGraph.loading")
        div.title.column
          span.fs-19 {{ displayInfo.title }} por {{ $ws('company') }}
          span.fs-13(v-if="displayedSelected.companiesGraph")
            | ({{ displayedSelected.companiesGraph.name }})

    .pie-companies

      PieChart(
      v-if="companiesFormated && !companiesGraph.loading",
      :data="companiesFormated",
      ref="companies",
      :options="pieChartConfig",
      key="companies",
      type="doughnut",
      @click="loadEmployeesGraph")
        template(v-if="typeView !== 'special'")
          div
            h3(style="display: inline;")
              | {{ companiesFormated.total.hours }}
            h5(style="display: inline;font-weight: 300;") h
          div(style="float: right;")
            h3(style="display: inline;")
              | {{ companiesFormated.total.minutes }}
            h5(style="display: inline;font-weight: 300;") min

        template(v-else="")
          div
            h3(style="display: inline;")
              | {{ companiesFormated.total.days }}
            h4(style="display: inline;font-weight: 300;") dias

      PieChart(v-if="companiesGraph.loading", type="doughnut", :data="loadingData.pie",
      :options="{animation: {duration: 7000, easing: 'easeOutBounce'}}")

    .companies-legends(v-if="companiesFormated")
      div(v-for="(item, index) in companiesFormated.legends")
        div(:style="{backgroundColor: item.color}")
          | {{ item.percent }}%
        label.to-click.fs-11(@click="openTimesheet(null, item.labelData)") {{ item.name }}
        label.fs-11 {{ item.total }} {{ typeView !== 'special' ? 'hrs' : 'dias' }}

    .employees-title
      template(v-if="employeesGraph.data || employeesGraph.loading")
        div.title.column
          span.fs-19 {{ displayInfo.title }} por {{ $ws('employee') }} do {{ $ws('company') }}
          span.fs-13(v-if="displayedSelected.employeesGraph")
            | ({{ displayedSelected.employeesGraph.name }})

    .pie-employees
      PieChart(
      v-if="employeesFormated && !employeesGraph.loading",
      :data="employeesFormated",
      ref="employees",
      :options="pieChartConfig",
      key="employees",
      type="doughnut")
        template(v-if="typeView !== 'special'")
          div
            h3(style="display: inline;")
              | {{ employeesFormated.total.hours }}
            h5(style="display: inline;font-weight: 300;") h
          div(style="float: right;")
            h3(style="display: inline;")
              | {{ employeesFormated.total.minutes }}
            h5(style="display: inline;font-weight: 300;") min

        // TODO back seams to return wrong total, dont display until fix it
        //template(v-else="")
          div
            h3(style="display: inline;")
              | {{ employeesFormated.total.days }}
            h4(style="display: inline;font-weight: 300;") dias

      PieChart(v-if="employeesGraph.loading", type="doughnut", :data="loadingData.pie",
      :options="{animation: {duration: 1000, easing: 'easeOutBounce'}}")

    .employees-legends(v-if="employeesFormated")
      div(v-for="(item, index) in employeesFormated.legends")
        div(:style="{backgroundColor: item.color}")
          | {{ item.percent }}%
        label.fs-11.to-click(@click="openTimesheet(item.labelData)") {{ item.name }}
        label.fs-11 {{ item.total }} {{ typeView !== 'special' ? 'hrs' : 'dias' }}

</template>

<script>
import PieChart from '../charts/PieChart'
import BarsChart from '../charts/BarsChart'
import { mapState } from 'vuex'
import moment from 'moment'
import { floatToHoursMins, genPalletFromBaseColors, round, floatToHoursMinsString } from 'src/utils'
import { formatLabelTofit } from 'src/components/DashBoards/utils'

export default {
  props: {
    labelCompany: {required: true},
    labelEmployee: {required: true},
    colors: {required: true}
  },
  data () {
    return {
      barsChartConfig: {
        tooltips: {
          titleMarginBottom: 10,
          bodyFontSize: 12,
          callbacks: {
            label: (item, data) => {
              if (this.typeView !== 'special') {
                return `${floatToHoursMinsString(item.yLabel)} hrs`
              } else {
                return `${data.datasets[0].data[item.index]} dias`
              }
            }
          }
        }
      },
      pieChartConfig: {
        tooltips: {
          titleMarginBottom: 10,
          bodyFontSize: 12,
          callbacks: {
            title: function pieChartToolTipTitle (item, data) {
              return data.labels[item[0].index]
            },
            label: (item, data) => {
              if (this.typeView !== 'special') {
                return `${floatToHoursMinsString(data.datasets[0].data[item.index])} hrs`
              } else {
                return `${data.datasets[0].data[item.index]} dias`
              }
            }
          }
        }
      },
      loadingData: {
        pie: {
          datasets: [{
            data: [10, 20, 30, 50, 12, 70]
          }],
          labels: [
            'Local a', 'Local b', 'Local c', 'Local d', 'Local e', 'Local f'
          ]
        },
        bars: {
          datasets: [
            {
              data: [1, 2, 3, 4, 5].map(i => Math.floor((Math.random() * 30) + 10)),
              field: 'a',
              backgroundColor: 'lightgray'
            }
          ],
          labels: ['Item a', 'Item b', 'Item c', 'Item D', 'Item E']
        }
      }
    }
  },
  components: {PieChart, BarsChart},
  computed: {
    ...mapState('dashboards',
      ['companies', 'types', 'typesSpecial', 'typesWhb', 'startDate', 'endDate', 'calendar', 'chartType', 'typeView']
    ),
    ...mapState('dashboards/pie',
      ['totalGraph', 'companiesGraph', 'employeesGraph', 'displayedSelected']
    ),
    displayInfo () {
      return {
        title: ({special: 'eventos', extraTime: 'apontamentos', whb: 'banco de horas'})[this.typeView],
        period: `de ${moment(this.startDate).format('DD.MM.YYYY')} - ${moment(this.endDate).format('DD.MM.YYYY')}`
      }
    },
    totalFormated () {
      if (!this.totalGraph.data) { return null }

      const formater = (i) => {
        return formatLabelTofit(i.name, 20, '/')
      }

      return this.formatGraph(this.totalGraph.data, formater, 'total')
    },
    companiesFormated () {
      if (!this.totalFormated || !this.companiesGraph.data) { return null }

      const formater = (i) => {
        return i.name
      }

      const data = this.formatGraph(this.companiesGraph.data, formater, 'companies')

      return this.legendsBuilder(data)
    },
    employeesFormated () {
      if (!this.companiesFormated || !this.employeesGraph.data) { return null }

      const formater = (i) => {
        return i.name
      }

      const data = this.formatGraph(this.employeesGraph.data, formater, 'employees')
      return this.legendsBuilder(data)
    }
  },
  methods: {
    loadTotalGraph () {
      this.$store.commit('dashboards/pie/companiesGraph', {data: null, loading: false})
      this.$store.commit('dashboards/pie/employeesGraph', {data: null, loading: false})

      const typesPerView = {
        'extraTime': this.types,
        'special': this.typesSpecial,
        'whb': this.typesWhb
      }

      this.$store.dispatch('dashboards/pie/loadGraphs', {
        view: 'total',
        chartType: 'bars',
        types: typesPerView[this.typeView].selected.map(l => l.id),
        companies: this.companies.selected.map(i => i.id)
      })
    },

    loadCompaniesGraph ({ labelClicked }) {
      this.$store.commit('dashboards/pie/employeesGraph', {data: null, loading: false})

      this.$store.commit('dashboards/pie/displayedSelected', {
        companiesGraph: labelClicked,
        useType: labelClicked.field
      })

      this.$store.dispatch('dashboards/pie/loadGraphs', {
        view: 'companies',
        types: [labelClicked.field],
        companies: this.companies.selected.map(i => i.id)
      })
    },

    loadEmployeesGraph ({ labelClicked }) {
      this.$store.commit('dashboards/pie/displayedSelected', {
        employeesGraph: labelClicked
      })
      this.$store.dispatch('dashboards/pie/loadGraphs', {
        view: 'employees',
        types: [this.$store.state.dashboards.pie.displayedSelected.useType],
        companies: [labelClicked.id]
      })
    },

    formatGraph (graphData, labelsFormater, type) {
      let datasets

      let total = null

      if (type !== 'total') {
        // lets remove the zero data because it dont appear in chart
        // and because it make the background colors so wrong

        const indexesToUse = graphData.datasets
          .map((item, index) => ({use: item.data[0].value !== 0, index}))
          .filter(i => i.use)
          .map(i => i.index)

        graphData.datasets = graphData.datasets.filter((i, index) => indexesToUse.includes(index))
        graphData.labelsData = graphData.labelsData.filter((i, index) => indexesToUse.includes(index))
      }

      const calcTotal = (graphName) => {
        if (this.typeView !== 'special') {
          const totalCalculated = floatToHoursMins(
            this[graphName].data.total[this.displayedSelected.companiesGraph.field]
          )
          return {
            hours: totalCalculated.hours,
            minutes: Math.round(totalCalculated.minutes),
            float: totalCalculated.float
          }
        } else {
          return {days: round(this[graphName].data.total[this.displayedSelected.companiesGraph.field], 1)}
        }
      }

      if (type === 'total') {
        datasets = [{
          data: graphData.datasets.map(i => i.value),
          backgroundColor: graphData.datasets.map(i => this.colors[i.field])
        }]
      } else {
        total = calcTotal(type === 'companies' ? 'companiesGraph' : 'employeesGraph')

        datasets = [{
          data: graphData.datasets.map(i => i.data[0].value),
          backgroundColor: genPalletFromBaseColors(
            graphData.datasets.length, ['#ffca54', '#ff6854', '#00a2b5', '#99c9d3']
          )
        }]
      }

      const labels = graphData.labelsData.map(labelsFormater)

      return {
        ...graphData,
        datasets,
        labels,
        total
      }
    },

    openTimesheet (employee, company) {
      this.$router.goToTimesheet(moment(), employee, company, true)
    },

    legendsBuilder (data) {
      const onesToConsidear = data.datasets[0].data
        .map((item, index) => ({item, index}))
        .sort((a, b) => b.item - a.item)
        .slice(0, 10)

      return {
        ...data,
        legends: onesToConsidear.map(({item, index}) => {
          let percent
          let total
          if (this.typeView !== 'special') {
            percent = round((item * 100) / data.total.float, 2)
            total = floatToHoursMinsString(item)
          } else {
            percent = round((item * 100) / data.total.days, 2)
            total = item
          }

          return {
            labelData: data.labelsData[index],
            name: data.labels[index],
            color: data.datasets[0].backgroundColor[index],
            percent,
            total
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.graph-total, .pie-employees, .pie-companies {
  width: 100%;
  box-sizing: border-box;
  height: 100%;
}
.pie-view-wrapper {
  position: relative;
  display: grid;
  /* padding-top: 40px; */
  padding-bottom: 40px;
  box-sizing: border-box;
  width: 100%;
  grid-template-areas:
    "total total total total"
    "companies-title companies-title employees-title employees-title"
    "companies companies-legends employees employees-legends";
  grid-row-gap: 20px;
  grid-template-rows: 1fr .2fr 1.3fr;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr); /* FOR GOD's SAKE, KEEP MINMAX TO AVOID FULLSCREEN ERROR  */
}
.graph-total {
  grid-area: total;
}
.pie-companies {
  grid-area: companies;
  display: grid;
  align-items: center;
  justify-items: center;
}
.pie-employees {
  grid-area: employees;
  display: grid;
  align-items: center;
  justify-items: center;
}
.companies-legends { grid-area: companies-legends }
.employees-legends { grid-area: employees-legends }
.companies-legends, .employees-legends {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.companies-legends > div, .employees-legends > div {
  display: grid;
  font-size: 15px;
  grid-template-columns: .3fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-column-gap: 5px;
}
.companies-legends > div > div, .employees-legends > div > div {
  padding: 0 5px 0 5px;
  font-size: 16px;
  height: 23px;
  width: 55px;
  color: white;
  display: grid;
  align-items: center;
  justify-content: center;
  align-self: start;
  justify-self: center;
  grid-column: 1 / 2;
  grid-row: 1 / 3;
}

.companies-title {
  grid-area: companies-title;
}
.employees-title {
  grid-area: employees-title;
}
.title {
  display: flex;
  align-items: center;
  justify-content: center;
}
.column {
  flex-direction: column;
}

.line {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
}
.change-chart-type {
  grid-area: change-chart;
  width: fit-content;
  height: fit-content;
  background-color: lightgray;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  margin-bottom: 10px;
  grid-column: 1;
}
.full-screen {
  grid-area: fullscreen;
  justify-self: end;
  grid-column: 2;
}
</style>
